import { render, staticRenderFns } from "./TablerowBase.vue?vue&type=template&id=74397412&scoped=true"
import script from "./TablerowBase.vue?vue&type=script&lang=js"
export * from "./TablerowBase.vue?vue&type=script&lang=js"
import style0 from "./TablerowBase.vue?vue&type=style&index=0&id=74397412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74397412",
  null
  
)

export default component.exports